































































































import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import { formatDuration } from '@tt4b/ttam-utils';
import { MaterialType } from '@tt4b/ttam-enums';
import { useAllowlist } from '@tt4b/ttam-hooks';
import { useVideoPlayer } from '../hooks/use-video-player';
import VideoPlayer from 'src/components/common/video-player/index.vue';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-library-list-item';

type ListItem = {
  id: number | string;
  vid: string;
  videoId: string;
  width: number;
  height: number;
  playUrl: string;
  previewUrl: string;
  imageUrl?: string;
  videoCode: number;
  cover_url?: string;
  videoInfo?: {
    coverUrl: string;
  };
  verify: {
    allPass: boolean;
    allReject: boolean;
    errorMsgs: string[];
  };
};

export default defineComponent({
  name,

  components: { VideoPlayer },

  props: {
    isAco: { type: Boolean, default: false },
    isPlayableType: { type: Boolean, default: false },
    limit: { type: Number, default: 20 },
    item: { type: Object as PropType<ListItem>, default: () => ({}) },
    selectedIds: { type: Array as PropType<number[]>, default: () => [] },
    type: { type: String as PropType<MaterialType>, default: undefined },
    acoVideoIdList: { type: Array as PropType<number[]>, default: () => [] },
    acoImageIdList: { type: Array as PropType<number[]>, default: () => [] },
    smbTea: { type: Boolean, default: false },
    noLazy: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const { selectedIds, isAco, isPlayableType, item, type, limit, acoVideoIdList, acoImageIdList } = toRefs(props);

    const { isPlayer, isVideoLoading, onMouseEnter, onMouseLeave } = useVideoPlayer(type.value);
    const { isCreativeHasIdentityWhite } = useAllowlist();

    /** 当前素材库类型是否是 native */
    const isNativeType = computed(() => type.value === MaterialType.Native);
    /** 当前项校验是否全部未通过 */
    const isItemAllReject = computed(() => item.value?.verify?.allReject);

    /** 素材是否可选 */
    const isItemNotSelectable = computed(() => {
      /** aco 已经选择过的，则不能再选 */
      const isInMaterialList =
        isAco.value && (acoVideoIdList.value.includes(item.value?.id) || acoImageIdList.value.includes(item.value?.id));
      const exceedLimit = selectedIds.value.length >= limit.value && !selectedIds.value.includes(item.value?.id);
      return isItemAllReject.value || exceedLimit || isInMaterialList;
    });

    /** 是否展示时长信息 */
    const isDurationVisible = computed(() =>
      [MaterialType.Native, MaterialType.Video, MaterialType.Affiliate].includes(type.value),
    );

    const isAffiliate = computed(() => MaterialType.Affiliate === type.value);

    /** 视频素材封面/图片素材地址 */
    const coverUrl = computed(() => {
      if (isPlayableType.value) {
        return item.value.previewUrl;
      }
      if ([MaterialType.Native, MaterialType.Affiliate].includes(type.value)) {
        return item.value?.videoInfo?.coverUrl ?? '';
      }
      return item.value?.imageUrl;
    });

    /** 根据素材宽高设置图片class名 */
    const imageClass = computed(() => {
      if (!item.value.height || !item.value.width) {
        return '';
      }
      if (item.value.height > item.value.width) {
        return 'material-library-image-vertical';
      } else if (item.value.height < item.value.width) {
        return 'material-library-image-horizontal';
      } else {
        return 'material-library-image-square';
      }
    });

    /** 根据素材宽高设置视频class名 */
    const videoClass = computed(() => {
      if (!item.value.height || !item.value.width) {
        return '';
      }
      if (item.value.height > item.value.width) {
        return 'material-library-video-vertical';
      } else if (item.value.height < item.value.width) {
        return 'material-library-video-horizontal';
      } else {
        return 'material-library-video-square';
      }
    });

    function onClickItem() {
      if (!isItemNotSelectable.value) {
        emit('click', item.value);
        if (isNativeType.value) {
          trackEvent('spark_ads_choose_post', {
            type: isCreativeHasIdentityWhite.value ? 'identity_structure' : 'spark_ads_structure',
          });
        }
      }
    }

    return {
      name,
      isPlayer,
      isVideoLoading,
      isDurationVisible,
      isItemNotSelectable,
      isItemAllReject,
      isAffiliate,

      coverUrl,
      imageClass,
      videoClass,
      formatDuration,
      onClickItem,
      onMouseEnter,
      onMouseLeave,
    };
  },
});
